// hooks/useUser.js
import { useState, useEffect } from "react";
import { getUserByDocument } from "../lib/actions";

export const useUser = () => {
  const [data, setData] = useState(null);
  // const [isCurrentUser, setIsCurrentUser] = useState(false);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const raw = localStorage.getItem("userId");
        if (raw) {
          const id = JSON.parse(raw);
          const userData = await getUserByDocument(id);
          setData(userData);
          // if (userData.$id === id) {
          //   setIsCurrentUser(true);
          // }
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    fetchUser();
  }, []);

  return { data };
};